import { breakpoints } from './breakpoints'

const buildMediaQuery = (value: string) => `@media screen and (min-width:${value})`

export const mediaQueries = {
    small: buildMediaQuery(breakpoints.small),
    medium: buildMediaQuery(breakpoints.medium),
    large: buildMediaQuery(breakpoints.large),
} as const
